import { IBankAccount } from "./createClient";

type ConsentBankData = {
  codigoBanco: string | number;
  agencia: string;
  conta: string;
  digitoConta: string;
  tipoConta?: string;
};

export const consentToBankAccount = (
  consent: ConsentBankData,
): IBankAccount => ({
  bank: String(consent.codigoBanco),
  agency: consent.agencia,
  agencyDigit: "",
  account: consent.conta,
  accountDigit: consent.digitoConta,
  accountType: consent.tipoConta,
});
